import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { SetupState } from './state';
import { IMaterial } from '@/interfaces';

const defaultState: SetupState = {
};

export const setupModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};

export interface IBasic {
  company_url: string | null;
  company_name: string;
  company_foundation_date: string | null;
  company_industry_category1: string | null;
  company_industry_detail1: string | null;
  company_industry_category2: string | null;
  company_industry_detail2: string | null;
  company_industry_category3: string | null;
  company_industry_detail3: string | null;
  company_growth_phase: string | null;
  user_last_name: string;
  user_first_name: string;
  user_title: string;
  user_expectation: string[];
}

export interface IProduct {
  product_name: string;
  product_url: string;
  product_description: string;
  product_materials: IMaterial[];
}

export interface ISetUpProduct {
  product: IProduct;
  upload_files: File[];
  delete_file_ids: number[];
}

export interface IFinance {
  finance_expect_finance_date: string;
  finance_expect_finance_amount: number | null;
  finance_expect_finance_method: string[];
  finance_expect_valuation_pre: number | null;
  finance_achievement: string;
  finance_use_of_funds: string[];
  user_need_consultation: boolean | null;
  finance_materials: IMaterial[];
}

export interface ISetUpFinance {
  finance: IFinance;
  upload_files: File[];
  delete_file_ids: number[];
}